import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { css, cx } from 'emotion';
import { TEXT_GRAY, DARK_GRAY, GRAY } from 'config/colors';

const navbar = css`
    width: 100%;
    background-color: ${GRAY};
    min-height: 40px;
    padding-top: 10px;
    border-bottom: 1px solid ${DARK_GRAY};
    overflow: hidden;
`;

const button = css`
    padding: 12px 16px;
    font-size: 14px;
    border: 1px solid ${DARK_GRAY};
    text-decoration: none;
    color: ${TEXT_GRAY};
    &:hover,
    &:active,
    &:focus {
        text-decoration: none;
        color: ${TEXT_GRAY};
    }
`;

const activeButton = css`
    color: ${TEXT_GRAY};
    font-weight: bold;
    background-color: #e5e6e7;
`;

const Navbar = ({ items, className, ...props }) => {
    return (
        <div className={cx([navbar, className])} {...props}>
            {items.map((item, index) => {
                if (!item) {
                    return null;
                }

                const { url, title } = item;

                return (
                    <NavLink
                        key={index}
                        to={url}
                        className={button}
                        activeClassName={activeButton}
                    >
                        {title}
                    </NavLink>
                );
            })}
        </div>
    );
};

Navbar.propTypes = {
    items: PropTypes.array,
    className: PropTypes.string,
};

export default Navbar;
